import { useState } from 'react'
import { Update_Current_User } from '@graphql/mutations'
import { useApi } from '@hooks/useApi'
import { mutate } from 'swr'
import { Current_User } from '@graphql/queries'

const useUpdateCurrentUser = () => {
  const [isPosting, setIsPosting] = useState(false)
  const { postMutation } = useApi()

  const post = async (data, successMessage, errorMessage) => {
    setIsPosting(true)

    const res = await postMutation(
      data,
      Update_Current_User,
      successMessage !== undefined ? successMessage : 'Ändringar sparade.',
      errorMessage ? errorMessage : 'Kunde inte spara ändringar.',
      async () => {
        await mutate(Current_User)
      }
    )

    setIsPosting(false)
    return res
  }

  return {
    post,
    isPosting,
  }
}

export { useUpdateCurrentUser }
